export default __webpack_public_path__ + "static/media/capsule-main-animation.c56f9362.mp4";